module.exports = __webpack_public_path__ + "img/case-ggg.b5fb31ab.png";